import { Dialog } from '@busybusy/webapp-react-ui';
import ProDetailsItem from 'components/foundation/details-item/ProDetailsItem/ProDetailsItem';
import { useOpenable } from 'hooks';
import { t } from 'i18next';
import IPosition from 'types/Position';
import SafetyObservationsForm from '../forms/SafetyObservationsForm';

export interface ISafetyObservationsDetailProps {
  position: IPosition;
  editable: boolean;
  onUpdate: () => Promise<any>;
}

const SafetyObservationsDetail = (props: ISafetyObservationsDetailProps) => {
  const { position, editable, onUpdate } = props;

  const detailOpenable = useOpenable();

  const onSubmitForm = () => {
    detailOpenable.close();
    onUpdate();
  };

  return (
    <>
      <ProDetailsItem
        title={t('Observations')}
        onClick={detailOpenable.open}
        value={position.reportObservations ? (position.manageObservations ? t('Manage') : t('Report Only')) : t('Off')}
        hint={t(
          'Allow the user to report safety concerns they may observe, as well as any positive safety observations.'
        )}
        disabled={!editable}
      />
      <Dialog position={'center'} isOpen={detailOpenable.isOpen} onClose={detailOpenable.close}>
        <SafetyObservationsForm
          onSubmit={onSubmitForm}
          reportObservations={position.reportObservations ?? false}
          manageObservations={position.manageObservations ?? false}
          positionId={position.id}
        />
      </Dialog>
    </>
  );
};

export default SafetyObservationsDetail;
